import React from 'react';
import { useProfileRebindModel } from './model';
import { ProfileRebindView } from './view';

export const ProfileRebindWidget: React.FC = () => {
  const { state, submit } = useProfileRebindModel();

  return <ProfileRebindView state={state} onSubmit={submit} />;
};
